import type {
  CompletedRefundTransaction,
  FailedRefundTransaction,
  Payment as GraphQlPayment,
  RefundInvoice,
} from '~/api/graphql/generated/types'
import type { PaymentMethod } from '~/constants/addPaymentDialogV2Constants'
import type { Payment } from '~/types'

export enum RefundFlowState {
  ISSUE_REFUND = 'ISSUE_REFUND',
  REFUND_PROCESSING = 'REFUND_PROCESSING',
  REFUND_SUCCESS = 'REFUND_SUCCESS',
}

export enum RefundMethod {
  CREDIT_DEBIT = 'CREDIT_DEBIT',
  CARECREDIT = 'CARECREDIT',
  CASH = 'CASH',
  CHECK = 'CHECK',
}

export interface RefundDialogContextType {
  actions: {
    cancelTransaction: () => void
    clearRefundError: () => void
    handleRefundTransactionFailure: (
      currentDialogState: RefundDialogStateType,
      transaction: FailedRefundTransaction,
    ) => void
    handleRefundTransactionHardFailure: (
      currentDialogState: RefundDialogStateType,
    ) => void
    handleRefundTransactionSuccess: (
      currentRefundState: RefundDialogStateType,
      transaction: CompletedRefundTransaction,
    ) => void
    resetDialog: () => void
    setRefundAmount: (amount: number) => void
    setRefundError: (error: {
      message: string
      severity: 'error' | 'warning'
      status: number
    }) => void
    setRefundMethod: (method: PaymentMethod) => void
    setSelectedPayment: (payment: GraphQlPayment | Payment | null) => void
    setSelectedPaymentTerminal: (
      terminalId: string,
      displayName: string,
    ) => void
    setState: (state: RefundFlowState) => void
    setTransactionId: (transactionId: string | null) => void
    submitLinkedRefund: (currentDialogState: RefundDialogStateType) => void
    submitManualRefund: (currentDialogState: RefundDialogStateType) => void
    submitUnlinkedRefund: (currentDialogState: RefundDialogStateType) => void
  }
  dialogState: RefundDialogStateType
  isLoading: boolean
  refundInvoice: RefundInvoice
}

export interface RefundDialogStateType {
  currentState: RefundFlowState
  hasPartialRefund: boolean
  isLinkedRefundListening: boolean
  linked: boolean
  partialRefundAmount: number
  refundAmount: number
  refundCardType: string | null
  refundError: {
    message: string
    severity: 'error' | 'warning'
    status: number
  } | null
  refundLastFour: string | null
  refundMethod: PaymentMethod
  selectedPayment: (GraphQlPayment | Payment) | null
  selectedPaymentTerminal: string | null
  selectedPaymentTerminalDisplayName: string | null
  transactionId: string | null
  unlinked: boolean
}
